import { render, staticRenderFns } from "./MeetingReportCover.vue?vue&type=template&id=5894080d&"
import script from "./MeetingReportCover.vue?vue&type=script&lang=js&"
export * from "./MeetingReportCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports